<template>
    <CompassTableHead class="reports-listing-table-head">
        <CompassTableHeadCell
            v-for="column in columns"
            :key="column.code"
            :sortable="column.sortable"
            :alignContent="column.alignContent"
            @click.native="$emit('sort-table-head', { orderBy: column.code })"
        >
            <span class="typographies-paragraph-medium-bold">
                {{ column.label }}
            </span>
        </CompassTableHeadCell>
    </CompassTableHead>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.reports-listing-table-head {
    position: sticky;
    top: 0;
    z-index: 3;
}
</style>
